import React, {useEffect, useState} from 'react';
import ElevenLabsIntegration from './pages/ElevenLabsIntegration';
import { BrowserRouter as Router, Route, Routes, Link, useParams } from 'react-router-dom';
import './App.css';
import axios from 'axios';
import CallElevenLabsTwilio from './pages/CallElevenLabsTwilio';
import PopupVega from './pages/PopupVega';
import HaroldPopup from './pages/HaroldPopup';
import logo from './imgs/LOGO_RIDOTTO.png';
import HumangestPage from './pages/customer/HumangestPage';
import MiraibayPage from './pages/customer/Miraibay';

function Home() {
  const [voiceBots, setVoiceBots] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchVoiceBots = async () => {
    try {
        //const response = await axios.get('https://otacon.it/wp-json/voicebot/v1/list');
        const response = await axios.get('https://deepagent.app/wp-json/deepagent/v1/list');
        setVoiceBots(response.data); // Salva i dati nello stato
        setIsLoading(false);
    } catch (err) {
        console.log(err);
    }
  };

  useEffect(() => {
      fetchVoiceBots();
  }, []);

  return (
    <div className="home-container">
      <img src={logo} alt="DeepAgent" className="logo"
      onClick={() => window.open('https://www.deepagent.app/', '_blank')}
      style={{ cursor: 'pointer' }}  />
      <a href="/call">Chiama GFU Bludental</a>
      <h1>DeepAgent Demo</h1>
      <div className="box-container">
        {isLoading ? (
          <p>Loading...</p>
        ) : (
          voiceBots?.map((agent) => {
            let agentName = agent?.personaggio.toLowerCase();
            return (
            <Link to={`/agent/${agentName}/${agent.id11labs}`} key={agent.id11labs} className="box">
              {agent.nome}
            </Link>
          )})
        )}
      </div>
    </div>
  );
}

function AgentPage({agent}) {
  const { agentId } = useParams();
  return (
    <ElevenLabsIntegration agentId={agentId} agent={agent} />
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/agent/:agentId" element={<AgentPage />} />
        <Route path="/agent/:agentName/:agentId" agent={"lucy"} element={<AgentPage />} />
        <Route path="/agent/:agentName/:agentId" agent={"charles"} element={<AgentPage />} />
        <Route path="/agent/:agentName/:agentId" agent={"lara"} element={<AgentPage />} />
        <Route path="/call" element={<CallElevenLabsTwilio />} />
        <Route path="/popup" element={<PopupVega/>} />
        <Route path="/harold-popup" element={<HaroldPopup/>} />
        <Route path="/agent/employerland" element={<HumangestPage />} />
        <Route path="/agent/miraibay" element={<MiraibayPage />} />
      </Routes>
    </Router>
  );
}

export default App;
